import {push as pushHistory} from 'react-router-redux';
import {addFlashMessage} from './flash-message';
import {removeAuthInfo} from './account';

export const formatErrors = (response = {}, redirectTo) => {
  const {message, status, ...errors} = response;
  const formFieldErrors = formatFieldErrors(errors);
  return (dispatch) =>
    new Promise((resolve) => {
      dispatch(addFlashMessage(message, 'error', status));
      redirect(dispatch, status, redirectTo);
      return resolve(formFieldErrors);
    });
};

export const formatFieldErrors = (errors) => {
  const ret = {};
  for (const [k, v] of Object.entries(errors)) {
    ret[k] = v[0];
  }
  return ret;
};

const redirect = (dispatch, statusCode, redirectTo) => {
  let action;
  switch (statusCode) {
    case 401:
      removeAuthInfo();
      action = pushHistory('/account/login');
      break;
    case 404:
      if (typeof redirectTo === 'string') {
        action = pushHistory(redirectTo);
      } else {
        action = pushHistory('/errors/404');
      }
      break;
    default:
      action = null;
  }
  if (action !== null) {
    dispatch(action);
  }
};
